import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  showDialog = false;

  constructor() { }

  ngOnInit() {
    // Show dialog after load
    this.showDialog = true;
  }

  closeDialog() {
    this.showDialog = false;
  }

  openAdmissionForm() {
    window.open('https://docs.google.com/forms/d/18R7GprImoUwWBrya4HjT9DNpFL9xcnmzjCKNWaXH2iU/edit', '_blank')
  }
}